/* ==========================================================================
   Planetry Prints · Send a sky (sections/pp-explore.liquid)
   --------------------------------------------------------------------------
   Drives the shared orrery engine (window.PPOrrery) full screen and composes
   the gift link:
     - starting date: ?date= (as shared links have always carried), then
       ?pp_date=, then the section's opening date, then today; ?to= and
       ?from= fill in the names;
     - the Date Field (its calendar has a year list; phones use their own
       date picker) and Today move the planets, which glide along their
       rings (1.4 to 2.4 s by distance);
     - the sky previews the gift as it will arrive: "For Sara" above it, the
       words and "From Adam" under it, then the date;
     - "Send this sky" builds <gift page>?date=&to=&msg=&from=, opens the
       share sheet where the device has one and copies the link where it
       does not, then shows the link with Messages, WhatsApp and Email;
     - hover (desktop) or tap (phones) a planet, or focus it in the key, for
       its annotation: EARTH · DAY 282 OF 366, MARS · 214° OF 360°;
     - Keep it too: both studios open on the date, the print with the words.
   No watermark (owner call, 2026-10-10).
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'];
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var coarse = window.matchMedia('(pointer: coarse)');

  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function iso(y, m, d) { return y + '-' + pad(m) + '-' + pad(d); }
  function daysIn(y, m) { return new Date(Date.UTC(y, m, 0)).getUTCDate(); }
  function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }
  /* Lenient on purpose: old shared links may carry 2021-8-1. */
  function parse(s) {
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(String(s || '').trim());
    if (!m) return null;
    var y = +m[1], mo = +m[2], d = +m[3];
    if (mo < 1 || mo > 12 || d < 1 || d > daysIn(y, mo)) return null;
    return { y: y, m: mo, d: d };
  }
  function todayISO() {
    var t = new Date();
    return iso(t.getFullYear(), t.getMonth() + 1, t.getDate());
  }
  function formatDate(v) {
    var p = parse(v);
    return p ? p.d + ' ' + MONTHS[p.m - 1] + ' ' + p.y : '';
  }
  function dayNumber(v) {
    var p = parse(v);
    return Date.UTC(p.y, p.m - 1, p.d) / 86400000;
  }
  function studioUrl(kind, date, extra) {
    if (window.PP && window.PP.studioUrl) return window.PP.studioUrl(kind, date, extra);
    var base = kind === 'case' ? '/products/sky-code-personalized-phone-case' : '/products/custom-planetry-art-print';
    var q = [];
    if (date) q.push('pp_date=' + encodeURIComponent(date));
    for (var k in (extra || {})) if (extra[k]) q.push(k + '=' + encodeURIComponent(extra[k]));
    return base + (q.length ? '?' + q.join('&') : '');
  }

  /* The gift page cleans every text parameter the same way (cleanMessage in
     planets/web-explorer/src/gift.js): one plain line, no links, emails or
     domains, capped on a word. Cleaning here too keeps the preview honest. */
  var INVISIBLE = /[\u0000-\u001f\u007f\u200b-\u200f\u2028\u2029\ufeff]/g;
  var STRIP = [
    /(https?:\/\/|www\.)[^\s]*/gi,
    /[^\s]+@[^\s]+/g,
    /[^\s]+\.(com|net|org|io|co|me|app|shop|store|site|online|page|xyz|info|biz|link|club|live|gg|tv|ca|us|uk|de|fr|ru|cn)(\/[^\s]*)?(?=[\s.,!?]|$)/gi
  ];
  function clean(s, max) {
    s = String(s || '').replace(INVISIBLE, ' ');
    for (var i = 0; i < STRIP.length; i++) s = s.replace(STRIP[i], ' ');
    s = s.replace(/\s+/g, ' ').trim();
    if (s.length > max) {
      var cut = s.slice(0, max + 1).replace(/\s+[^\s]*$/, '');
      if (!cut.length || cut.length > max) cut = s.slice(0, max);
      s = cut.trim();
    }
    return s;
  }

  function init(root) {
    if (!root || root.ppExplore || !window.PPOrrery) return;
    var O = window.PPOrrery;

    var cfg = {};
    try { cfg = JSON.parse(root.getAttribute('data-pp-config') || '{}'); } catch (e) { cfg = {}; }
    var minYear = Math.min(cfg.minYear || 1900, cfg.maxYear || 2100);
    var maxYear = Math.max(cfg.minYear || 1900, cfg.maxYear || 2100);
    var glideMin = cfg.glideMin == null ? 1400 : cfg.glideMin;
    var glideMax = Math.max(glideMin, cfg.glideMax == null ? 2400 : cfg.glideMax);
    var giftCfg = cfg.gift || {};
    var shareCfg = cfg.share || {};
    var maxMsg = giftCfg.maxMessage || 100;
    var maxName = giftCfg.maxName || 30;

    var host = root.querySelector('[data-ppe-host]');
    var spot = root.querySelector('[data-ppe-spot]');
    var annos = root.querySelector('[data-ppe-annos]');
    var readout = root.querySelector('[data-ppe-readout]');
    var live = root.querySelector('[data-ppe-live]');
    var caseNote = root.querySelector('[data-ppe-case-note]');
    var fieldEl = root.querySelector('[data-pp-datefield]');

    var form = root.querySelector('[data-ppe-form]');
    var toInput = root.querySelector('[data-ppe-to]');
    var fromInput = root.querySelector('[data-ppe-from]');
    var msgInput = root.querySelector('[data-ppe-msg]');
    var count = root.querySelector('[data-ppe-count]');
    var showFor = root.querySelector('[data-ppe-show-for]');
    var showWords = root.querySelector('[data-ppe-show-words]');
    var showText = root.querySelector('[data-ppe-show-text]');
    var showFrom = root.querySelector('[data-ppe-show-from]');
    var previewLinks = root.querySelectorAll('[data-ppe-preview]');
    var editBtn = root.querySelector('[data-ppe-edit]');
    var ready = root.querySelector('[data-ppe-ready]');
    var readyTitle = root.querySelector('[data-ppe-ready-title]');
    var linkField = root.querySelector('[data-ppe-link]');
    var copyBtn = root.querySelector('[data-ppe-copy]');
    var status = root.querySelector('[data-ppe-status]');

    /* ---- starting date and names ----------------------------------------- */
    var url = null;
    try { url = new URL(window.location.href); } catch (e1) { url = null; }
    var start = (url && (parse(url.searchParams.get('date')) || parse(url.searchParams.get('pp_date')))) ||
      parse(cfg.date) || parse(todayISO());
    start = clampParts(start);

    function clampParts(p) {
      var y = clamp(p.y, minYear, maxYear);
      var m = clamp(p.m, 1, 12);
      return { y: y, m: m, d: clamp(p.d, 1, daysIn(y, m)) };
    }

    if (url) {
      var givenTo = clean(url.searchParams.get('to'), maxName);
      var givenFrom = clean(url.searchParams.get('from'), maxName);
      if (toInput && givenTo) toInput.value = givenTo;
      if (fromInput && givenFrom) fromInput.value = givenFrom;
    }

    var current = iso(start.y, start.m, start.d);
    var orrery = O.create(host, {
      theme: 'black',
      fit: 'system',
      rules: false,
      zoom: cfg.zoom || 1,
      date: current,
      unwrap: true,
      animateMs: 0,
      starSeed: cfg.starSeed || 20260802
    });

    function fitSpot() {
      var hr = host.getBoundingClientRect();
      var sr = spot.getBoundingClientRect();
      if (!hr.width || !hr.height || !sr.width || !sr.height) return;
      orrery.setViewBox({
        x: (sr.left - hr.left) / hr.width,
        y: (sr.top - hr.top) / hr.height,
        w: sr.width / hr.width,
        h: sr.height / hr.height
      });
      placeAnnos();
    }

    /* ---- geometry: where each planet dot sits, in host pixels ---------- */
    var bodies = {};
    O.BODIES.forEach(function (b) { bodies[b.name] = b; });

    function view() {
      var t = orrery.stage.style.transform || '';
      var m = /translate\(\s*([-\d.e]+)px,\s*([-\d.e]+)px\)\s*scale\(\s*([-\d.e]+)\s*\)/.exec(t);
      return m ? { tx: +m[1], ty: +m[2], k: +m[3] } : null;
    }

    /* The dot is the ring's ::before, centred on the inner edge of its
       3.2px border at 12 o'clock; the ring turns by -angle about its centre,
       inside .solar-syst-inner, scaled by INNER_SCALE about ORIGIN. */
    function planetXY(name, angle) {
      var b = bodies[name], v = view();
      if (!b || !v) return null;
      var S = O.INNER_SCALE;
      var cx = O.ORIGIN.x + (b.ml + b.orb / 2) * S;
      var cy = O.ORIGIN.y + (b.mt + b.orb / 2) * S;
      var r = (b.orb / 2 - 3.2) * S;
      var a = angle * Math.PI / 180;
      var x = cx - r * Math.sin(a);
      var y = cy - r * Math.cos(a);
      return { x: v.tx + x * v.k, y: v.ty + y * v.k };
    }

    /* ---- how far round its orbit -------------------------------------
       Earth: the day of the year. Every other world: degrees travelled
       since the line where Earth stood on 1 January of that year, the
       same starting line the Sky Code Case counts from. */
    var angles = O.anglesFor(current);
    var startLine = 0;

    function measure() {
      angles = O.anglesFor(current);
      var p = parse(current);
      startLine = O.anglesFor(iso(p.y, 1, 1)).earth;
    }

    function labelFor(name) {
      var p = parse(current);
      if (name === 'earth') {
        var n = dayNumber(current) - Date.UTC(p.y, 0, 1) / 86400000 + 1;
        var total = (p.y % 4 === 0 && (p.y % 100 !== 0 || p.y % 400 === 0)) ? 366 : 365;
        return { short: 'Earth · Day ' + Math.round(n) + ' of ' + total, long: 'Earth: day ' + Math.round(n) + ' of ' + total };
      }
      var deg = Math.round(((angles[name] - startLine) % 360 + 360) % 360) % 360;
      var nm = name.charAt(0).toUpperCase() + name.slice(1);
      return { short: nm + ' · ' + deg + '° of 360°', long: nm + ': ' + deg + ' degrees of its 360 degree orbit' };
    }

    /* ---- annotations ---------------------------------------------------- */
    var shown = {};          /* name -> element */
    var settled = true;
    var hoverName = null, pinName = null, focusName = null;

    function makeAnno(name) {
      var el = doc.createElement('div');
      el.className = 'pp-anno ppe__anno';
      el.setAttribute('data-name', name);
      el.innerHTML = '<span class="pp-anno__line"></span><span class="pp-anno__label"></span>';
      annos.appendChild(el);
      return el;
    }

    /* Earth's label shows by default where there is room beside the sky;
       on phones every label waits for a tap. */
    function wanted() {
      var list = fine.matches ? ['earth'] : [];
      [pinName, hoverName, focusName].forEach(function (n) {
        if (n && list.indexOf(n) === -1) list.push(n);
      });
      return list;
    }

    function placeAnnos() {
      if (!annos) return;
      var want = settled ? wanted() : [];
      Object.keys(shown).forEach(function (n) {
        if (want.indexOf(n) === -1) {
          var gone = shown[n];
          gone.classList.remove('is-drawn');
          delete shown[n];
          setTimeout(function () { if (gone.parentNode) gone.parentNode.removeChild(gone); }, 260);
        }
      });
      var w = annos.clientWidth;
      want.forEach(function (n) {
        var pt = planetXY(n, angles[n]);
        if (!pt) return;
        var el = shown[n] || (shown[n] = makeAnno(n));
        el.querySelector('.pp-anno__label').textContent = labelFor(n).short;
        /* Point the label away from the nearer edge, then keep it inside. */
        var width = el.offsetWidth || 220;
        var left = pt.x > w * 0.62;
        if (!left && pt.x + width > w - 8 && pt.x - width >= 8) left = true;
        if (left && pt.x - width < 8 && pt.x + width <= w - 8) left = false;
        el.classList.toggle('pp-anno--left', left);
        if (left) { el.style.left = 'auto'; el.style.right = (w - pt.x) + 'px'; }
        else { el.style.right = 'auto'; el.style.left = pt.x + 'px'; }
        el.style.top = pt.y + 'px';
        if (!el.classList.contains('is-drawn')) {
          requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-drawn'); }); });
        }
      });
    }

    function clearAnnos() {
      Object.keys(shown).forEach(function (n) {
        var el = shown[n];
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      shown = {};
    }

    /* ---- text equivalent ------------------------------------------------ */
    function describe() {
      if (live) live.textContent = 'Showing the planets on ' + formatDate(current) + '.';
      root.querySelectorAll('[data-ppe-pos]').forEach(function (n) {
        n.textContent = labelFor(n.getAttribute('data-ppe-pos')).long;
      });
    }

    /* ---- the gift: words, link, preview ---------------------------------- */
    function words() {
      return {
        to: clean(toInput && toInput.value, maxName),
        msg: clean(msgInput && msgInput.value, maxMsg),
        from: clean(fromInput && fromInput.value, maxName)
      };
    }

    function giftLink() {
      var w = words();
      try {
        var g = new URL(giftCfg.url || '/pages/planet-gift', window.location.href);
        g.search = '';
        g.hash = '';
        g.searchParams.set('date', current);
        if (w.to) g.searchParams.set('to', w.to);
        if (w.msg) g.searchParams.set('msg', w.msg);
        if (w.from) g.searchParams.set('from', w.from);
        return g.toString();
      } catch (e3) { /* fall through to a link back here */ }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('date', current);
        return u.toString();
      } catch (e4) { return window.location.href; }
    }

    var via = {};
    root.querySelectorAll('[data-ppe-via]').forEach(function (el) { via[el.getAttribute('data-ppe-via')] = el; });
    /* Messages only where a phone can open it; More where there is a share sheet. */
    if (via.sms) via.sms.hidden = !coarse.matches;
    if (via.share) via.share.hidden = !navigator.share;

    function syncVia(link) {
      var line = shareCfg.line || 'I saved a day for you.';
      /* The link always goes last, so nothing can run on into its words. */
      if (via.sms) via.sms.setAttribute('href', 'sms:?&body=' + encodeURIComponent(line + ' ' + link));
      if (via.whatsapp) via.whatsapp.setAttribute('href', 'https://wa.me/?text=' + encodeURIComponent(line + ' ' + link));
      if (via.email) {
        via.email.setAttribute('href', 'mailto:?subject=' + encodeURIComponent(line.replace(/[.!\s]+$/, '')) +
          '&body=' + encodeURIComponent(line + '\n\n' + link));
      }
    }

    function syncLinks() {
      var w = words();
      var caseOk = current >= (cfg.caseMin || '1900-01-01') && current <= (cfg.caseMax || '2050-12-31');
      root.querySelectorAll('[data-pp-studio]').forEach(function (a) {
        if (a.getAttribute('data-pp-studio') === 'case') a.setAttribute('href', studioUrl('case', caseOk ? current : ''));
        else a.setAttribute('href', studioUrl('print', current, w.msg ? { pp_message: w.msg.slice(0, 80) } : null));
      });
      if (caseNote) caseNote.hidden = caseOk;
    }

    function preview() {
      var w = words();
      if (showFor) showFor.textContent = w.to ? 'For ' + w.to : '';
      if (showFrom) showFrom.textContent = w.from ? 'From ' + w.from : '';
      if (showText) showText.textContent = w.msg;
      if (showWords) {
        if (w.msg) showWords.removeAttribute('data-empty');
        else showWords.setAttribute('data-empty', '');
        showWords.setAttribute('data-size', w.msg.length > 60 ? 'long' : (w.msg.length > 30 ? 'mid' : 'short'));
      }
      if (count && msgInput) count.textContent = msgInput.value.length + '/' + maxMsg;
      var link = giftLink();
      Array.prototype.forEach.call(previewLinks, function (a) { a.setAttribute('href', link); });
      if (linkField) linkField.value = link;
      syncVia(link);
      syncLinks();
    }

    /* ---- apply a date ---------------------------------------------------- */
    var settleTimer = null;

    function goTo(value, from) {
      var p = parse(value);
      if (!p) return;
      p = clampParts(p);
      var next = iso(p.y, p.m, p.d);
      var prev = current;
      current = next;

      var ms = 0;
      if (!reduce.matches && from !== 'init') {
        var years = Math.abs(dayNumber(next) - dayNumber(prev)) / 365.25;
        ms = Math.round(glideMin + (glideMax - glideMin) * Math.min(1, years / 60));
      }
      orrery.options.animateMs = ms;
      orrery.setDate(next);
      measure();

      settled = false;
      clearAnnos();
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () { settled = true; placeAnnos(); }, ms + 80);

      if (readout) readout.textContent = formatDate(next);
      if (from !== 'field' && fieldEl && fieldEl.ppField) fieldEl.ppField.set(next, true);
      preview();
      describe();

      if (from !== 'init' && cfg.syncUrl !== false && url && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('date', next);
          u.searchParams.delete('pp_date');
          history.replaceState(history.state, '', u.toString());
        } catch (e2) { /* a sandboxed frame may refuse; harmless */ }
      }
    }

    /* ---- inputs ------------------------------------------------------------ */
    root.addEventListener('pp:datechange', function (e) {
      if (e.detail && e.detail.value) goTo(e.detail.value, 'field');
    });

    [toInput, fromInput, msgInput].forEach(function (el) {
      if (el) el.addEventListener('input', preview);
    });
    /* Enter moves on through the names instead of sending; the words are one
       line, like the print's. */
    if (toInput) toInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); if (fromInput) fromInput.focus(); }
    });
    if (fromInput) fromInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); if (msgInput) msgInput.focus(); }
    });
    if (msgInput) msgInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); if (coarse.matches) msgInput.blur(); }
    });

    /* Hover on desktop, tap on phones: the nearest dot within reach. */
    function nearest(clientX, clientY, reach) {
      var r = annos.getBoundingClientRect();
      var x = clientX - r.left, y = clientY - r.top;
      var best = null, bestD = reach;
      O.NAMES.forEach(function (n) {
        var pt = planetXY(n, angles[n]);
        if (!pt) return;
        var d = Math.sqrt((pt.x - x) * (pt.x - x) + (pt.y - y) * (pt.y - y));
        if (d < bestD) { bestD = d; best = n; }
      });
      return best;
    }

    var moveFrame = null;
    root.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !settled) return;
      if (e.target !== host && !host.contains(e.target)) {
        if (hoverName) { hoverName = null; placeAnnos(); }
        return;
      }
      if (moveFrame) return;
      moveFrame = requestAnimationFrame(function () {
        moveFrame = null;
        var n = nearest(e.clientX, e.clientY, 26);
        if (n !== hoverName) { hoverName = n; placeAnnos(); }
        host.style.cursor = n ? 'pointer' : '';
      });
    });
    root.addEventListener('pointerleave', function () {
      if (hoverName) { hoverName = null; placeAnnos(); }
    });
    host.addEventListener('click', function (e) {
      if (!settled) return;
      var n = nearest(e.clientX, e.clientY, fine.matches ? 26 : 38);
      pinName = (n && n !== pinName) ? n : null;
      placeAnnos();
    });

    root.querySelectorAll('[data-ppe-planet]').forEach(function (b) {
      var n = b.getAttribute('data-ppe-planet');
      b.addEventListener('mouseenter', function () { focusName = n; placeAnnos(); });
      b.addEventListener('mouseleave', function () { if (focusName === n) { focusName = null; placeAnnos(); } });
      b.addEventListener('focus', function () { focusName = n; placeAnnos(); });
      b.addEventListener('blur', function () { if (focusName === n) { focusName = null; placeAnnos(); } });
      b.addEventListener('click', function () { pinName = pinName === n ? null : n; placeAnnos(); });
    });

    /* ---- Send this sky ----------------------------------------------------- */
    var statusTimer = null;
    function flash(text) {
      if (!status) return;
      status.textContent = text;
      clearTimeout(statusTimer);
      statusTimer = setTimeout(function () { status.textContent = ''; }, 2600);
    }
    function legacyCopy(link) {
      var ta = doc.createElement('textarea');
      ta.value = link;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      ta.style.fontSize = '16px';   /* under 16px, iPhones zoom into a focused field */
      doc.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = doc.execCommand('copy'); } catch (e5) { ok = false; }
      doc.body.removeChild(ta);
      if (ok) flash(shareCfg.copied || 'Link copied');
      else if (linkField) { linkField.focus(); linkField.select(); }
    }
    function copy(link) {
      var clip = navigator.clipboard;
      if (clip && clip.writeText) clip.writeText(link).then(function () { flash(shareCfg.copied || 'Link copied'); }, function () { legacyCopy(link); });
      else legacyCopy(link);
    }
    /* The gift travels IN the url: share it with a title only. Text beside
       the url can be merged into it by some share targets, and would then
       arrive inside the msg parameter. */
    function shareSheet(link) {
      return navigator.share({ title: (shareCfg.line || 'I saved a day for you.').replace(/[.!\s]+$/, ''), url: link });
    }

    /* Two steps in one place: the form, then the link with every way to send
       it. The ready step takes the form's place, so nothing below it moves;
       "Change something" brings the form back with everything kept. */
    function setStep(step) {
      if (!ready) return;
      var isReady = step === 'ready';
      /* The ready step is shorter than the form: hold the form's height so
         the heading and the sky stay exactly where they were. */
      if (form) form.style.minHeight = isReady ? (form.style.minHeight || form.offsetHeight + 'px') : '';
      ready.hidden = !isReady;
      if (isReady) root.setAttribute('data-ppe-step', 'ready');
      else root.removeAttribute('data-ppe-step');
    }

    function showReady() {
      setStep('ready');
      if (readyTitle) readyTitle.focus({ preventScroll: true });
      var r = form && form.getBoundingClientRect();
      if (r && (r.top < 0 || r.top > window.innerHeight * 0.6) && form.scrollIntoView) {
        form.scrollIntoView({ block: 'start', behavior: reduce.matches ? 'auto' : 'smooth' });
      }
    }

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      preview();
      var link = giftLink();
      showReady();
      if (navigator.share) shareSheet(link)['catch'](function () { /* dismissed: the step has every other way */ });
      else copy(link);
    });
    if (editBtn) editBtn.addEventListener('click', function () {
      setStep('compose');
      if (msgInput) msgInput.focus();
    });
    if (copyBtn) copyBtn.addEventListener('click', function () { copy(giftLink()); });
    if (linkField) linkField.addEventListener('focus', function () { linkField.select(); });
    if (via.share) via.share.addEventListener('click', function () {
      shareSheet(giftLink())['catch'](function () {});
    });

    /* ---- layout ------------------------------------------------------------ */
    fitSpot();
    if (window.ResizeObserver) {
      new ResizeObserver(function () { requestAnimationFrame(fitSpot); }).observe(spot);
      new ResizeObserver(function () { requestAnimationFrame(fitSpot); }).observe(host);
    } else {
      window.addEventListener('resize', fitSpot);
    }
    window.addEventListener('load', fitSpot);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(fitSpot);

    goTo(current, 'init');
    root.ppExplore = { orrery: orrery, goTo: goTo, giftLink: giftLink };
  }

  function boot(scope) {
    if (window.PP && window.PP.initDateFields) window.PP.initDateFields(scope || doc);
    (scope || doc).querySelectorAll('[data-pp-explore]').forEach(init);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  doc.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
